import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { deleteDocument } from '@/features/documents/api/delete-documents';
import { toast } from '@/shared/hooks/use-toast';

export const useDeleteDocument = () => {
  const { t } = useTranslation('document');
  return useMutation({
    mutationFn: deleteDocument,
    onError: (error) => {
      toast({
        title: t('Errors.delete_error'),
        description: error.message,
      });
    },
  });
};
